import clsx from 'clsx'
// import { ZodIssue as $ZodIssue } from 'zod'
import { TRPCClientError } from '@trpc/client'
import { $ZodIssue } from 'zod/v4/core'
import $type from '@tandem/ui/type.css'
import $layout from '@tandem/ui/layout.css'
import $form from '@tandem/ui/form.css'
import { HTMLAttributes } from 'react'
import { useToast } from './Toast'
import { parseZodIssues } from './trpc/errors'
import { TriangleAlertIcon } from 'lucide-react'

function defaultFormatter(error: $ZodIssue) {
  if (error.code === 'too_small') {
    if (error.minimum === 1) {
      return 'Обязательное поле.'
    } else {
      return `Минимальная длина ${error.minimum}.`
    }
  } else if (error.code === 'invalid_value') {
    return 'Выберите вариант.'
  } else if (error.code === 'invalid_format' && error.format === 'email') {
    return 'Неправильный адрес электронной почты.'
  }
}

export default function Errors({
  errors,
  format,
  formatter = defaultFormatter,
  ...rest
}: {
  errors: any[]
  format?: Record<string, string>
  formatter?: (error: $ZodIssue) => string | undefined
} & HTMLAttributes<HTMLDivElement>) {
  if (!errors || errors.length === 0) {
    return null
  }

  return (
    <div {...rest} class={clsx($layout.col, $type.error, $form.error, rest.class)}>
      {errors.map((error, index) => {
        return <div key={index}>{format?.[error.code] || formatter(error) || error.message || String(error)}</div>
      })}
    </div>
  )
}

export function formatErrors(
  errors: any[],
  format?: Record<string, string>,
  formatter?: (error: $ZodIssue) => string | undefined
) {
  if (!errors || errors.length === 0) {
    return ''
  }

  return errors.map((error) => format?.[error.code] || formatter?.(error) || error.message || String(error)).join(' ')
}

export function validationErrorToast() {
  let toast = useToast()
  return (error: any) => {
    if (
      error instanceof TRPCClientError &&
      error.data?.code === 'BAD_REQUEST' &&
      error.data?.issues
    ) {
      toast(formatErrors(error.data.issues))
    }
  }
}
